<template>
    <div class="autobooker-step" :class="{ active, retrying }" @click="$emit('click')">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-auto">
                    <i v-if="step.status === 'SUCCESS'" class="mdi mdi-check-circle status-icon success"></i>
                    <i v-if="step.status === 'FAILED'" class="mdi mdi-close-circle-outline status-icon failed"></i>
                    <i v-if="step.status === 'CREATED'" class="mdi mdi-circle-outline status-icon"></i>
                    <i v-if="step.status === 'RUNNING'" class="mdi mdi-play-circle-outline status-icon running"></i>
                    <i v-if="step.status === 'RETRY_REQUESTED'" class="mdi mdi-refresh status-icon retrying"></i>
                </div>
                <div class="col">
                    <span class="step-title">{{ step.name }}</span><br>
                    <span class="step-status" v-if="retrying">Retrying.. check back later<br></span>
                    <span class="step-status" v-if="step.status === 'RUNNING'">Running.. check back later<br></span>
                    <span class="step-message">{{ step.status_message }}</span>
                    <div v-if="active && !retrying && step.budget_original" class="step-details">
                        <table class="table table-sm table-hover">
                            <tbody>
                            <tr>
                                <th>Assigned budget</th>
                                <td>
                                    EUR {{ step.budget_original }}
                                </td>
                            </tr>
                            <tr>
                                <th>Expected required budget</th>
                                <td>
                                    <span v-if="step.budget_required_expected">
                                        EUR {{ step.budget_required_expected }}
                                    </span>
                                    <span v-else class="text-muted">
                                        Unknown
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Spent</th>
                                <td>
                                    EUR {{ step.budget_spent }} <span
                                        v-if="step.status !== 'SUCCESS' && step.status !== 'FAILED'" class="text-muted">(Warning: Not finished yet.)</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="step.purchases.length > 0">
                            <div class="step-label">Purchases</div>
                            <div v-for="purchase in step.purchases" :key="purchase.id" :purchase="purchase"
                                 class="purchase-card">
                                <table class="table table-sm table-hover">
                                    <tbody>
                                    <tr>
                                        <th colspan="2">{{ purchase.label }}</th>
                                    </tr>
                                    <tr>
                                        <th>Source</th>
                                        <td>{{ purchase.source }}</td>
                                    </tr>
                                    <tr>
                                        <th>Source reference</th>
                                        <td>{{ purchase.source_reference }}</td>
                                    </tr>
                                    <tr v-if="purchase.hotel_rooms">
                                        <th>&nbsp;</th>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr v-if="purchase.hotel_rooms">
                                        <th>Rooms</th>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr v-for="room in purchase.hotel_rooms">
                                        <th>{{ room.quantity }}x {{ room.name }}</th>
                                        <td>
                                            <table>
                                                <tbody>
                                                <tr>
                                                    <th>Paid</th>
                                                    <td>EUR {{ room.cost_price }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Rate description</th>
                                                    <td>{{ room.rate_description }}</td>
                                                </tr>
                                                <tr v-if="room.cancellation_policies">
                                                    <th>Cancellation</th>
                                                    <td>
                                                        <div v-for="(policy, i) in room.cancellation_policies">
                                                            <hr v-if="room.cancellation_policies.length > 1 && i > 0">
                                                            <div v-if="policy.starts_at && policy.ends_at">
                                                                Cancel between
                                                                {{ new Date(policy.starts_at).toLocaleString() }} -
                                                                {{ new Date(policy.ends_at).toLocaleString() }}
                                                                <br> EUR {{ policy.fee }}
                                                            </div>
                                                            <div v-else-if="policy.ends_at">
                                                                Cancel before
                                                                {{ new Date(policy.ends_at).toLocaleString() }}
                                                                <br> EUR {{ policy.fee }}
                                                            </div>
                                                            <div v-else-if="policy.starts_at">
                                                                Cancel after
                                                                {{
                                                                    new Date(policy.starts_at).toLocaleString()
                                                                }}
                                                                <br> EUR {{ policy.fee }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="step-close-button-wrapper">
                            <span v-if="step.can_retry && !retrying">
                                <a href="#" class="step-action btn btn-sm btn-link"
                                   @click.stop.prevent="$emit('retry')">Retry</a> -
                            </span>
                            <a href="#" class="step-action btn btn-sm btn-link" @click.stop.prevent="$emit('close')">Close
                                details</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AutobookerStep',

    props: {
        step: {
            type: Object,
            required: false
        },
        active: {
            type: Boolean,
            required: true
        },
        retrying: {
            type: Boolean,
            required: false
        }
    }
};
</script>
